import LogOutSvg from '@assets/images/svg/log-out.svg';
import React from 'react';
import { View } from 'react-native';

export interface LogOutIconProps {
    size?: number;
    color?: string;
    strokeWidth?: number;
}

export function LogOutIcon({ size = 18, color = '#1A1A1A', strokeWidth = 2 }: LogOutIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <LogOutSvg width={size} height={size} color={color} strokeWidth={strokeWidth} />
        </View>
    );
}



